import styled from 'styled-components';

export const Container = styled.div`

    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    align-items: center;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // -user-select: none;
    -webkit-tap-highlight-color: transparent;

    p {
        margin: 0
    }

    .div-pai {
        margin: 32px;
        background-color: #fff;
        max-width: 1096px;
        min-width: 300px;
        width: 88%;
        border-radius: 8px;

        @media (max-width: 1330px) {
            margin-bottom: 80px;
            width: 100%
        }

        @media (max-width: 691px) {
            margin-top: 153px;
            margin-bottom: 80px;
            margin-left: 390px;
        }

        .div-rota {
            margin-right: 16px;
            margin-top: 40px;
            margin-left: 32px;
            width: 90%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis;

            @media(max-width: 360px) {
                margin-left: 16px
            }
            
            span {
                font-family: Montserrat;
                font-size: 14px;
                color: #2a0709;
                font-weight: 500;

                @media(max-width: 690px) {
                    font-size: 12px;
                }
            }

            .rotas {
                font-family: Montserrat;
                font-size: 14px;
                color: #a49b9b;
                font-weight: normal;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }
        }
    }

        .emoji {
            width: 32px;
            height: 32px;
            margin-top: 40px;
            margin-left: 32px;
            margin-bottom: 24px;
            object-fit: contain;

            @media(max-width: 360px) {
                    margin-left: 16px;
                    margin-top: 32px
                }
        }

        h1 {
            font-family: Montserrat;
            font-size: 32px;
            margin-top: 0;
            margin-left: 32px;
            margin-right: 16px;
            margin-bottom: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 690px) {
                margin-left: 23px;
                font-size: 24px;
            }
        }

        h5 {
            margin-top: 24px;
            margin-left: 32px;
            margin-right: 56px;
            margin-bottom: 40px;           
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 690px) {
                margin-left: 26px;
                margin-bottom: 24px;  
                margin-right: 0px; 
                font-size: 14px;
            }
        }

        h2 {
            @media(max-width: 690px) {
                font-size: 20px;
            }
        }

        h4 {
            margin-top: 64px;
            margin-bottom: 40px;
            margin-left: 32px;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
                margin-left: 16px;
                margin-top: 68px;
                margin-bottom: 36px;
            }
        }

        .pages {
            width: 100%;
            padding-left: 8px;
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 56px;

            .page {
                background-color: #fff;
                margin-left: 24px;
                margin-top: 24px;
                cursor: pointer;
                width: 100%;
                max-width: 382px;
                border-radius: 8px;
                border: 1.5px solid #dedede;

                @media (max-width: 510px) {
                    width: 80%;
                }

                @media (max-width: 360px) {
                    margin-left: 8px;
                    margin-top: 16px;
                    width: 89%;
                }

                .emoji {
                    margin-top: 32px;
                    margin-left: 32px;

                    @media(max-width: 360px) {
                            margin-left: 16px;
                        }
                }

                .botao {
                    display: flex;
                    width: 100%;
                    padding-left: 32px;
                    margin-bottom: 32px;

                    @media(max-width: 510px) {
                        padding-left: 0px;
                        align-items: center;
                        justify-content: center;
                    }

                    .salvar {
                        cursor: pointer;
                        height: 40px;
                        width: 92px;
                        background-color: #fff;
                        outline: none;
                        border: none;
                        border-radius: 20px;
                        justify-content: center;
                        align-items: center;
                        color: #c42027;
                        border: 1.5px solid #c42027;
                        font-family: Montserrat;
                        font-size: 11px;
                        font-weight: 600;
                        transition: 0.2s;

                        :hover {
                            background-color: #9c1a1f
                        }

                        :active {
                            background-color: #d7232c
                        }

                        @media(max-width: 510px) {
                            width: 83%;
                        }

                        @media(max-width: 360px) {
                            width: 90%;
                            height: 32px;
                        }
                    }
                }

                :hover {
                    border: 1.5px solid #a49a9b;
                    -webkit-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
                    -moz-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
                    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);

                    .salvar {
                        background-color: #c32027;
                        color: #fff;
                    }
                }

                h4 {
                    margin: 0;
                    padding-left: 32px;
                    padding-bottom: 16px;

                    @media (max-width: 360px) {
                        padding-left: 16px;
                    }
                }
            }
        }

        hr {
            display: block; 
            height: 1px;
            border: 0; 
            border-top: 2px solid #f3f3f3;
            margin: 1em 0; 
            padding: 0;
        }

        .linha {
            width: 95%;
            border-top: 2px solid #f3f3f3;
            margin: auto;
            margin: 64px 32px;

            @media(max-width: 691px) {
                margin: 56px 0px;
                margin-top: 44px;
                margin-bottom: 15px;
                margin-left: 7px;
            }   
        }

        .periodo {
            display: flex;
            flex-direction: column;
            padding: 0 32px;
    
            @media(max-width: 360px) {
                margin-bottom: -56px;
                 padding: 0 16px;
            }
        }

        .subtexto {
            margin-top: 24px;
            margin-right: 56px;
            margin-bottom: 60px;           
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 690px) {
                margin-bottom: 30px;
                margin-top: 0px;   
                font-size: 14px;
                margin-right: 5px;
            }
        }

        .options  {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            flex-direction: row;

            @media(max-width: 690px) {
                width: 100%;
                padding: 0px
            }

            .option {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;

                @media(max-width: 360px) {
                    padding: 6px 14px;
                }

                @media(max-width: 784px) {
                    padding: 12px 25px;
                }

                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #2a0709;

                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }

            .option-selected {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                background-color: #2a0709;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;

                @media(max-width: 360px) {
                    padding: 6px 14px;
                }

                @media(max-width: 784px) {
                    padding: 12px 24px;
                }

                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #fff;

                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
        }
        .vendas {
            display: flex;
            flex-direction: column;
            padding: 0 32px;
    
            @media(max-width: 360px) {
                margin-bottom: -56px;
                 padding: 0 16px;
            }
        }

        .row1{
            display: flex;

            @media(max-width: 690px){
            flex-direction: column;
            }
        }

        .borda{
            // box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding: 32px;
            padding-right: 0px;
            gap: 12px;
            position: relative;
            width: 325px;
            height: 124px;
            margin-left: 32px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 8px;
            padding-bottom: 0px;

            @media(max-width: 690px){
                position: relative;
                width: auto;
                height: auto;
                margin-left: 16px;
                margin-right: 16px;
                padding-top: 24px;
                padding-left: 18px;
                padding-right: 0px;
                margin-bottom: 12px;
                padding-bottom: 20px;
            }

            @media (min-width: 691px) and (max-width: 1000px) {
                margin-right: 31px;
            }
        }

        .nota{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 32px;
            line-height: 32px;
            color: #2D2D2D;

            @media(max-width: 690px){
                font-size: 24px;
                line-height: 24px;
            }
        }

        .star{
                margin-top: 24px;
                margin-right: 56px;
                margin-bottom: 40px;           
                font-family: Montserrat;
                font-size: 14px;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: left;
    
                @media(max-width: 360px) {
                    margin-left: 16px;
                    margin-bottom: 24px;   
                }
            }

            @media(max-width: 690px) {
                width: 14px;
                height: 14px;
                padding-top: 8px;
                padding-bottom: 0px;
            }    
        }

        .paginacao{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            color: #000000;
            margin-left: 32px;
            margin-top: 40px;

            @media(max-width: 690px){
                font-size: 12px;
                margin-top: 24px; 
            }
        }

        .paginas{
            font-style: normal;
            font-family: Montserrat;
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            color: #000000; 
          
            @media(max-width: 690px){
                font-size: 12px;
            }
        }

        .borda3{
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 40px 24px;
            padding-right: 24px;
            margin-right: 48px;
            margin-top: 20px;
            margin-bottom: 35px;
            margin-left: 32px;
            gap: 24px;
            // position: relative;
            width: auto;
            left: 24px;
            top: 24px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 16px;

            // @media(max-width: 360px){
            //     width: auto;
            //     height: 136px;
            //     left: 16px;
            //     margin-right: 16px;
            //     padding: 24px;
            //     margin-bottom: 16px;
            //     }

            @media(max-width: 690px){
                width: auto;
                height: auto;
                margin-left: 16px;
                margin-right: 16px;
                padding-top: 24px;
                padding-left: 18px;
                padding-right: 0px;
                margin-bottom: 12px;
                padding-bottom: 20px;
            }
        }

            .conteudo{
                display: flex;

                @media(max-width: 691px) {
                 padding-bottom: 0px;
                }   
            }

            .user{
                width: 40px;
                height: 40px; 
                padding-right: 12px;
            }

            .userName{
                font-family: 'Montserrat';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 16px;
                color: #2D2D2D;

                @media(max-width: 690px){
                  font-size: 14px;
                }
            }

            .row-mobile{
                display: flex;
                @media(max-width: 690px){
                }
            }

            .subtexto1{
                font-family: 'Montserrat';
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                color: #2D2D2D;
                display: flex;
                margin-top: 8px;

                @media(max-width: 690px){
                    font-size: 10px;
                }
            }

            .salvar-branco {
                /* margin-bottom: -56px;  */
                cursor: pointer;
                height: 40px;
                width: 160px;
                background-color: #fff;
                border: 1px solid #c32027;
                outline: none;
                border-radius: 20px;
                justify-content: center;
                align-items: center;
                color: #c32027;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 600;
                transition: 0.2s;
                margin-left: 500px;
                margin-top: -20px;
    
                :hover {
                    background-color: #c32027;
                    color: #fff
                }
    
                :active {
                    background-color: #9c1a1f;
                    color: #fff
                }
                @media(max-width: 690px) {
                    display: none;
                }
                
                @media (min-width: 691px) and (max-width: 1000px) {
                    margin-left: 250px;
                }
            }

            .salvar-branco-celular {
                /* margin-bottom: -56px;  */
                display: none;
                cursor: pointer;
                height: 40px;
                width: 160px;
                background-color: #fff;
                border: 1px solid #c32027;
                outline: none;
                border-radius: 20px;
                justify-content: center;
                align-items: center;
                color: #c32027;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 600;
                transition: 0.2s;
                margin-left: 500px;
                margin-top: -20px;
    
                :hover {
                    background-color: #c32027;
                    color: #fff
                }
    
                :active {
                    background-color: #9c1a1f;
                    color: #fff
                }
                @media(max-width: 690px) {
                    width: 100%;
                    margin-left: -5px;
                    display: flex;
                    flex-direction: column;
                    margin-top: 20px;
                }
                
            }

            .paginacaoEnd{
                font-family: 'Montserrat';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 24px;
                color: #000000;
                margin-top: 40px;
                margin-left: 435px;
                padding-top: 64px;
                position: relative;
                margin-bottom: 64px;
    
                @media(max-width: 690px){
                    font-size: 12px;
                    margin-left: 124px;
                    padding-top: 8px;
                    padding-bottom: 8px;
                }

                @media (min-width: 691px) and (max-width: 900px) {
                    font-size: 12px;
                    margin-left: 200px;
                    padding-top: 8px;
                    padding-bottom: 8px;
                }
                
            }

            .paginas1{ 
                font-style: normal;
                font-family: Montserrat;
                font-weight: 700;
                font-size: 14px;
                line-height: 24px;
                color: #000000; 
                margin-right: 27px;
                width: 40px;
                height: 40px;
                border-radius: 4px;
                background-color: #FBFAFA;
                border: #FBFAFA;
              
                
                @media(max-width: 690px){
                    font-size: 12px;
                    margin-right: 14px;
                }
    
                :hover {
                    background-color: #FBFAFA;
                }
            }

            .button{
                outline: none;
                border: none;
                background-color: #fff;
                color: #D7232C;
                font-weight: 600;
                margin-right: 36px;   
                
                @media(max-width: 690px){
                    margin-right: 14px;
                }
            }

            .button1{
                outline: none;
                border: none;
                background-color: #fff;
                color: #D7232C;
                font-weight: 600;
                margin-right: 10px;
            }

            .arrow{
                margin-right: 10px;
                margin-left: 10px;
            }


    

    }
`